// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"292":"aa8915fa","879":"78b67a8f"}[chunkId] + ".css";
};